var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("updated landing")]),_vm._v(" "+_vm._s(_vm.landingPages)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }